var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"logo",attrs:{"src":require("@/assets/logo.png"),"max-width":"220"}})}
var staticRenderFns = []

export { render, staticRenderFns }